import React, {useContext} from 'react'
import {NullAsDefault} from 'views/Shared'
import Translate from "../../../../modules/local/Translate";
import {Avatar} from "antd";
import {BiSolidChurch, BiSolidMapPin, BiSolidPhone} from "react-icons/bi";
import {getFullAddress, renderIf, renderIfElse} from "../../../Shared";
import _ from "lodash"
import CRUD from "../../../Shared/enums/CRUD";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {GiChurch} from "react-icons/gi";
import useTranslate from "../../../../modules/local/useTranslate";
import {useChurches} from "./useChurches";
import {ChurchColorSvg} from "../../../../components/Svgs/ChurchColorSvg";
import TooltipApp from "components/TooltipApp";


export const renderChurch = ({renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {

    const {
        name,
        photo,
        contact_name,
        contact_phone,
        address,
        country,
        ward,
        district,
        province,
        is_cathedral,
        parish,
    } = item ?? {}

    return (
        <LayoutContext.Consumer>
            {({isSm}) => (
                <Translate key={index}>
                    {(t) => (
                        <div className="flex gap-2 md:gap-3 rounded-lg custom-item-render custom-render-border relative">
                            <div className="relative">
                                <Avatar
                                    size={isSm ? 80 : 100}
                                    className="flex flex-center background-200 rounded-l-lg rounded-r-0 cursor-pointer"
                                    src={photo}
                                    icon={<BiSolidChurch size={isSm ? 40 : 60} style={{color: '#dddddd'}}/>}
                                    onClick={() => {
                                        handleAction(CRUD.READ, item)
                                    }}
                                />
                                {renderIf(
                                    !!is_cathedral,
                                    <div
                                        onClick={() => {
                                            handleAction(CRUD.READ, item)
                                        }}
                                        style={{background: 'linear-gradient(to right bottom, rgb(255 255 255 / 70%) 15%, rgba(255, 255, 255, 0) 65%)'}}
                                        className="absolute top-0 w-full h-full rounded-l-md cursor-pointer"
                                    />
                                )}
                                {renderIf(
                                    !!is_cathedral,
                                    <TooltipApp title={t('cathedral')} placement="right"
                                                classNames={{root: "font-medium text-xs italic"}}>
                                        <GiChurch
                                            size={22}
                                            style={{top: 8, left: 8}}
                                            className="absolute text-blue-500 hover:text-blue-700 cursor-pointer"
                                        />
                                    </TooltipApp>
                                )}
                            </div>
                            <div className="flex flex-col flex-1 gap-1 py-1 md:py-2 pr-1">
                                <div style={{lineHeight: 1.15}} className="mr-6 space-x-1 max-lines-2">
                                    <span
                                        onClick={() => {handleAction(CRUD.READ, item)}}
                                        className="font-bold text-sm md:text-base text-color-000 hover:text-primary cursor-pointer">
                                        {name}
                                    </span>
                                    {renderIf(
                                        parish,
                                        <span className="font-medium text-xs text-blue-500 italic">
                                            {`(${t('belong to')} ${parish?.fullname})`}
                                        </span>
                                    )}
                                </div>
                                {renderIf(
                                    _.some([contact_name, contact_phone]),
                                    <div className="flex items-center gap-1 italic text-xs">
                                        {isSm ?
                                            <BiSolidPhone size={isSm ? 12 : 14} className="text-color-500"/> :
                                            <span className="text-color-500">
                              {`${t('contact')} : `}
                          </span>
                                        }
                                        {renderIfElse(
                                            contact_name && contact_phone,
                                            <span
                                                className="flex-1 font-medium md:font-semibold text-color-300 leading-tight">
                              {`${contact_name} - ${contact_phone}`}
                          </span>,
                                            <span
                                                className="flex-1 font-medium md:font-semibold text-color-300 leading-tight">
                              {contact_name || contact_phone}
                          </span>
                                        )}
                                    </div>
                                )}
                                {renderIf(
                                    _.some([address, country?.location_name, ward?.location_name, district?.location_name, province?.location_name]),
                                    <div className="flex items-start md:items-center gap-1 italic text-xs">
                                        {isSm ?
                                            <BiSolidMapPin size={isSm ? 12 : 14} style={{marginTop: isSm && 3}} className="text-color-500"/> :
                                            <span className="text-color-500">
                                                {`${t('address')} : `}
                                            </span>
                                        }
                                        <span className="flex-1 font-medium md:font-semibold text-color-300 max-lines-1 leading-snug">
                                            {getFullAddress(item)}
                                        </span>
                                    </div>
                                )}
                                {renderIf(
                                    !!!item?.active,
                                    <div
                                        style={{position: 'absolute', bottom: 5, right: 10}}
                                        className="font-medium text-2xs text-orange-500 italic leading-snug">
                                        {t('inactive')}
                                    </div>
                                )}
                            </div>
                            {renderIf(
                                !!item?.edit && _.isFunction(renderContextMenu),
                                <div className="absolute right-5 top-5 contextIcon">
                                    {renderContextMenu(item)}
                                </div>
                            )}
                        </div>
                    )}
                </Translate>
            )}
        </LayoutContext.Consumer>
    )
}

export const ChurchItemCompact = ({item}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const {
        name,
        photo,
        address,
        country,
        ward,
        district,
        province,
        church_type,
    } = item ?? {}

    const {churchModal, showDialog} = useChurches({
        notifyListeners: {}
    })

    return (
        <React.Fragment>
            <div className="flex items-center gap-3 ml-3">
                <ChurchColorSvg size={60} className="opacity-85"/>
                <div className="flex flex-col flex-1 py-1">
                    <div
                        onClick={() => showDialog(item)}
                        style={{marginBottom: 3}}
                        className="font-semibold text-sm text-primary-600 hover:text-primary leading-snug cursor-pointer">
                        {name}
                    </div>
                    {renderIf(
                        _.some([address, country?.location_name, ward?.location_name, district?.location_name, province?.location_name]),
                        <div className="space-x-1 text-xs">
                            {renderIf(
                                !isSm,
                                <span className="text-color-500 italic">
                                    {`${t('address')} : `}
                                </span>
                            )}
                            <span className="flex-1 font-medium md:font-semibold text-color-300 leading-snug">
                                {getFullAddress(item)}
                            </span>
                        </div>
                    )}
                    <div
                        onClick={() => showDialog(item)}
                        className="text-right text-doc-2xs text-color-400 hover:text-color-100 italic cursor-pointer tracking-wide leading-snug mt-1">
                        {`${t('view detail')}...`}
                    </div>
                </div>
            </div>
            {churchModal}
        </React.Fragment>
    )
}
